// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__2hakv","load8":"Spinner_load8__1FLaS","Container":"Spinner_Container__1E4m4","Icon":"Spinner_Icon__IDHEw"};